import TextWithIcon from 'components/TextWithIcon';
import JobLabels from 'components/JobLabels';
import { Link } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { ReactComponent as Arrow } from 'assets/icons/arrow-right.svg';

const JobCard = ({ item }) => {
    const { experience, locations, slug, title, work_type, desc, date } = item;
    const labels = [
        { type: 'experience', text: experience },
        { type: 'locations', text: locations },
        { type: 'work_type', text: work_type },
    ];
    return (
        <Link to={`${ROUTES.career}/${slug}`} className="job-card">
            <div className="job-card__title">
                <span>{title}</span>
                <Arrow />
            </div>
            <div className="job-card__description opacity-70 body1">{desc || '!!add description'}</div>
            <JobLabels data={labels} />
            <TextWithIcon iconName="calendar" text={date || '!!add date'} />
        </Link>
    );
};

export default JobCard;
